import { ENewbuildingSnippetType, IOfferCard } from '../../../../types';

import { getOfferSubtitle } from '../../utils/getOfferSubtitle';
import { isNewbuilding, getOfferName } from '../../utils';

export const prepareSubtitle = (offerCard: IOfferCard) => {
  const { isTop3, isPremium, title, newbuilding } = offerCard;

  const generatedTitle = getOfferName(offerCard);

  const generatedSubtitle = (isTop3 || isPremium) && Boolean(title) ? getOfferName(offerCard) : undefined;

  return getOfferSubtitle({
    isNewbuilding: isNewbuilding(offerCard),
    originalSubtitle: generatedSubtitle,
    house: newbuilding?.house,
    hideCompletionDate: Boolean(newbuilding?.snippetType === ENewbuildingSnippetType.Maximum) && !!title,
    additionalTextBegin:
      newbuilding?.snippetType === ENewbuildingSnippetType.Maximum && title ? generatedTitle : undefined,
  });
};
